<template>
    <div>
        <el-empty description="页面没找到"></el-empty>
    </div>
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style scoped>

</style>
